import clsx from 'clsx';

import s from './inputs.module.scss';

export const Switch = ({
  checked,
  onChange,
  className,
  disabled,
}: {
  checked: boolean;
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
  className?: string;
  disabled?: boolean;
}) => {
  return (
    <label className={clsx(s.Switch, checked && s.checked, disabled && s.disabled, className)}>
      <div className={s.circle} />
      <input
        className={s.input}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
    </label>
  );
};
